import {System} from './../../shared-components/System';
import {Injectable} from '@angular/core';
import {YearService} from '../../shared-components/year/year.service';
import {StudentService} from '../../shared-components/student/student.service';
import {ProgramAndService} from './programs-and-services.model';
import {HttpClient} from '@angular/common/http';
import {SharedService} from '../../shared-components/shared.service';

@Injectable()
export class ProgramsAndServicesService {

    // Properties

    // Class Functions
    constructor(
        private yearService: YearService,
        private studentService: StudentService,
        private http: HttpClient,
        private sharedService: SharedService
    ) {
    }

    // Event Functions

    // Methods
    getProgramsAndServices(viewOption = 0) {
        // POST: obtains the programs and services for the student in the selected year
        const queryString = '?studentId=' + this.studentService.selectedStudent.Id +
            '&yearId=' + this.yearService.student360Year.Id +
            '&siteYearId=' + this.studentService.studentEnrollment.SiteYearId +
            '&viewOption=' + viewOption;
        return this.http.get<ProgramAndService[]>(System.apiURL.Student + 'GetProgramAndServices' + queryString);
    }
}
